import {Component, OnInit} from '@angular/core';
import {ContextService} from '@services/context.service';
import {Router} from '@angular/router';
import {SharedImports} from '@shared/shared-imports';
import {ContextModel} from '@app/models/context.model';
import {EnvironmentsService} from '@services/environments.service';
import {Title} from '@angular/platform-browser';

declare const Beacon: any;

@Component({
  selector: 'app-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
  imports: [SharedImports]
})
export class PublicComponent implements OnInit {
  logo: string;
  tenant: string;

  constructor(public contextService: ContextService, private router: Router, private environmentsService: EnvironmentsService,
              private titleService: Title) {
  }

  ngOnInit(): void {
    if (!this.router.url.includes('/two-factor-auth')) {
      sessionStorage.clear();
    }
    this.getBaseUrl();
  }

  getBaseUrl() {
    return new Promise((resolve, reject) => {
      this.environmentsService.getEnvironment(window.location.hostname).then((rtnTenant) => {
        if (rtnTenant) {
          this.setUrl(rtnTenant);
        }

      });
      resolve(null);
    });
  }

  setUrl(rtnTenant) {
    const context = {} as ContextModel;
    context.apiBaseUrlV1 = rtnTenant.apiBaseUrlV1;
    context.apiBaseUrlV2 = rtnTenant.apiBaseUrlV2;
    context.tenantName = rtnTenant.tenantEnum;
    context.tenantLogo = rtnTenant.tenantLogo;
    context.accessToken = null;
    context.multiTenant = rtnTenant.multiTenant;

    this.titleService.setTitle(rtnTenant.pageTitle);
    sessionStorage.setItem('pageTitle', rtnTenant.pageTitle);
    this.contextService.contextObject = context;
    this.logo = this.contextService.contextObject.tenantLogo;
    if (!this.tenant) {
      this.tenant = this.contextService.contextObject.tenantName;
    }
    if (this.contextService.contextObject.tenantName !== 'IUPAT') {
      this.loadHelpScout();
    }
  }

  loadHelpScout() {
    Beacon('init', {
      beaconId: '7a93590b-a928-4758-9525-a039449dc28c',
    });
  }
}
